<template>
  <div class="editor">
    <div class="header-actions">
      <p class="hint">Campos extras que o inscrito vai preencher alem dos basicos (nome, CPF, email, telefone).</p>
      <button v-if="!showAdd" type="button" class="btn-primary" @click="abrirAdd">+ Adicionar campo</button>
    </div>

    <div v-if="showAdd" class="add-form">
      <h4 class="add-title">Novo campo</h4>
      <div class="add-grid">
        <div class="form-row">
          <label class="label">Pergunta (label)</label>
          <input class="input" v-model="novo.label" placeholder="Ex: Sua celula" @input="autoFillKey" />
        </div>
        <div class="form-row">
          <label class="label">Chave (key)</label>
          <input class="input" v-model="novo.key" placeholder="ex: celula" @input="novo.key = novo.key.replace(/[^a-zA-Z0-9_]/g, '')" />
        </div>
        <div class="form-row">
          <label class="label">Tipo</label>
          <select class="select" v-model="novo.tipo">
            <option value="text">Texto curto</option>
            <option value="textarea">Texto longo</option>
            <option value="number">Numero</option>
            <option value="date">Data</option>
            <option value="select">Lista de opcoes</option>
            <option value="checkbox">Checkbox (sim/nao)</option>
          </select>
        </div>
        <div class="form-row check-row-wrap">
          <label class="check-row">
            <input type="checkbox" v-model="novo.obrigatorio" />
            <span>Obrigatorio</span>
          </label>
        </div>
      </div>
      <div v-if="novo.tipo === 'select'" class="form-row">
        <label class="label">Opcoes (1 por linha)</label>
        <textarea class="textarea" rows="3" v-model="opcoesRaw" placeholder="P&#10;M&#10;G&#10;GG"></textarea>
      </div>
      <div v-if="novo.tipo === 'number'" class="add-grid">
        <div class="form-row">
          <label class="label">Min</label>
          <input class="input" type="number" v-model.number="novo.min" />
        </div>
        <div class="form-row">
          <label class="label">Max</label>
          <input class="input" type="number" v-model.number="novo.max" />
        </div>
      </div>

      <div v-if="addError" class="error-msg">{{ addError }}</div>
      <div class="add-actions">
        <button type="button" class="btn-secondary" @click="cancelarAdd">Cancelar</button>
        <button type="button" class="btn-primary" @click="adicionar">Adicionar</button>
      </div>
    </div>

    <div v-if="modelValue.length === 0 && !showAdd" class="empty-msg">
      Nenhum campo extra. Clique em "+ Adicionar campo" pra criar.
    </div>

    <ul v-else-if="modelValue.length > 0" class="list">
      <li v-for="(c, idx) in modelValue" :key="idx" class="item">
        <div class="item-head">
          <strong>{{ c.label || '(sem label)' }}</strong>
          <span class="tipo">{{ c.tipo }}</span>
          <span v-if="c.obrigatorio" class="req">obrig.</span>
          <div class="item-actions">
            <button type="button" class="link-btn" @click="move(idx, -1)" :disabled="idx === 0">↑</button>
            <button type="button" class="link-btn" @click="move(idx, 1)" :disabled="idx === modelValue.length - 1">↓</button>
            <button type="button" class="link-btn link-danger" @click="remove(idx)">remover</button>
          </div>
        </div>
        <div class="item-meta">
          <code>{{ c.key }}</code>
          <span v-if="c.opcoes?.length">[{{ c.opcoes.join(', ') }}]</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
function emptyNovo() {
  return { key: '', label: '', tipo: 'text', obrigatorio: false, min: null, max: null }
}

export default {
  name: 'CamposCustomEditor',
  props: { modelValue: { type: Array, default: () => [] } },
  emits: ['update:modelValue'],
  data() {
    return { novo: emptyNovo(), opcoesRaw: '', addError: '', showAdd: false }
  },
  methods: {
    abrirAdd() {
      this.novo = emptyNovo()
      this.opcoesRaw = ''
      this.addError = ''
      this.showAdd = true
    },
    cancelarAdd() {
      this.showAdd = false
      this.addError = ''
    },
    autoFillKey() {
      if (this.novo.key) return
      const k = this.novo.label.toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]/g, '_').replace(/^_+|_+$/g, '').slice(0, 30)
      this.novo.key = k
    },
    move(idx, delta) {
      const arr = [...this.modelValue]
      const tgt = idx + delta
      if (tgt < 0 || tgt >= arr.length) return
      ;[arr[idx], arr[tgt]] = [arr[tgt], arr[idx]]
      this.$emit('update:modelValue', arr)
    },
    remove(idx) {
      const arr = [...this.modelValue]
      arr.splice(idx, 1)
      this.$emit('update:modelValue', arr)
    },
    adicionar() {
      this.addError = ''
      const k = this.novo.key.trim()
      const l = this.novo.label.trim()
      if (!k || !/^[a-z][a-zA-Z0-9_]*$/.test(k)) { this.addError = 'Chave invalida (use letras minusculas, sem espaco).'; return }
      if (!l) { this.addError = 'Pergunta (label) obrigatoria.'; return }
      if (this.modelValue.some(c => c.key === k)) { this.addError = 'Chave duplicada.'; return }
      const campo = {
        key: k, label: l, tipo: this.novo.tipo,
        obrigatorio: this.novo.obrigatorio
      }
      if (this.novo.tipo === 'select') {
        const opcoes = this.opcoesRaw.split('\n').map(s => s.trim()).filter(Boolean)
        if (opcoes.length === 0) { this.addError = 'Adicione ao menos 1 opcao.'; return }
        campo.opcoes = opcoes
      }
      if (this.novo.tipo === 'number') {
        if (this.novo.min !== null && this.novo.min !== '') campo.min = Number(this.novo.min)
        if (this.novo.max !== null && this.novo.max !== '') campo.max = Number(this.novo.max)
      }
      this.$emit('update:modelValue', [...this.modelValue, campo])
      this.novo = emptyNovo()
      this.opcoesRaw = ''
      this.showAdd = false
    }
  }
}
</script>

<style scoped>
.editor { display: flex; flex-direction: column; gap: var(--spacing-base); }
.header-actions { display: flex; align-items: center; justify-content: space-between; gap: var(--spacing-md); }
.hint { color: var(--color-text-muted); font-size: var(--text-sm); margin: 0; flex: 1; }
.add-actions { display: flex; gap: var(--spacing-sm); justify-content: flex-end; margin-top: var(--spacing-sm); }
.empty-msg {
  padding: var(--spacing-base);
  background: var(--color-bg-hover);
  border-radius: var(--radius-md);
  color: var(--color-text-muted); font-size: var(--text-sm);
  text-align: center;
}
.list { list-style: none; display: flex; flex-direction: column; gap: var(--spacing-sm); }
.item {
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--color-bg-hover);
  border-radius: var(--radius-md);
}
.item-head { display: flex; align-items: center; gap: var(--spacing-sm); flex-wrap: wrap; }
.tipo { font-size: var(--text-xs); color: var(--color-text-muted); }
.req { font-size: 10px; background: #fef3c7; color: #92400e; padding: 1px 6px; border-radius: 3px; }
.item-actions { margin-left: auto; display: flex; gap: 4px; }
.link-btn {
  background: none; border: none; cursor: pointer;
  color: var(--color-accent); font-size: var(--text-xs); padding: 2px 6px;
}
.link-btn:disabled { opacity: 0.3; cursor: not-allowed; }
.link-danger { color: var(--color-danger); }
.item-meta {
  margin-top: 4px;
  font-size: var(--text-xs); color: var(--color-text-muted);
}
.item-meta code { background: #fff; padding: 1px 4px; border-radius: 3px; }
.add-form {
  border: 1px dashed var(--color-bg-separator);
  border-radius: var(--radius-md);
  padding: var(--spacing-base);
  display: flex; flex-direction: column; gap: var(--spacing-md);
}
.add-title { font-size: var(--text-sm); color: var(--color-text-heading); }
.add-grid { display: grid; grid-template-columns: 1fr 1fr; gap: var(--spacing-sm); }
.form-row { display: flex; flex-direction: column; gap: 4px; }
.check-row-wrap { justify-content: flex-end; }
.check-row { display: flex; align-items: center; gap: 6px; font-size: var(--text-sm); cursor: pointer; }
@media (max-width: 540px) {
  .add-grid { grid-template-columns: 1fr; }
}
</style>
